/** Live uploads list; persisted payload is intentionally empty. */
export type FilesConfig = Record<string, never>;

export function normalizeFilesConfig(input: unknown): FilesConfig {
  void input;
  return {};
}

export function stringifyFilesConfig(data: FilesConfig): string {
  void data;
  return JSON.stringify({}, null, 2);
}
